module.exports = __webpack_public_path__ + "static/media/employee.769105f4.svg";